import React from 'react'
import { useRef, useEffect } from 'react';
import './homenew.css'
import StatusContext from '../../../contexts/StatusContext';
import AuthContext from '../../../contexts/AuthContext';
import { DialogLogout } from '../home/DialogLogout';
import {Row, Col} from 'react-bootstrap';
import { LoginDialog } from '../logindialog/LoginDialog';
//import Stack from '@mui/material/Stack'
import { useNavigate } from 'react-router-dom';


export const HomeNew = () => {

  const hasExecuted = useRef(false);
  
  let {
    isMobile,
    isMe,
    changeLanguage,
    dialogLogoutText,
    openLogoutDialog,
    setDialogLogoutText,
    setOpenLogoutDialog,

  } = React.useContext(StatusContext);

  let {
    logout,

  } = React.useContext(AuthContext);

  /*
   const styleAIModel = {
   
    fontSize:'14px',
    color:'maroon',
    fontWeight:'500',
 };
  */
 const navigate = useNavigate();

  useEffect(() => {

    console.log('UseEffect: HomeNew')
    if (localStorage.getItem('Logout') === 'Yes')
    {
      if (hasExecuted.current) return; // Prevent execution if already executed
      console.log("Open Logout dialog")
      localStorage.setItem('Logout', 'No')
      setDialogLogoutText(changeLanguage('login', 'logouttext'))
      setOpenLogoutDialog(true)
      logout()
      hasExecuted.current = true; // Mark as executed
    }

    }, [changeLanguage, logout, setDialogLogoutText, setOpenLogoutDialog])
   

    const confirmYes = () => {
     setOpenLogoutDialog(false)
    }

    const closeLogoutDialog = () => {
      setOpenLogoutDialog(false)
    }

  return (

    <div className='homeContainer'>

            <div className="homenewMainTitle" >
              DedaAI
            </div>
           
            <div className="homenewMainSubtitle" style={{fontSize:'18px'}}>
            {changeLanguage('home', 'moto')}
            </div>
        {/*
          !isMobile() ?
         
            <div className="homenewMainSubtitle" style={{width:'60%', color:'maroon', fontSize:'14px'}}>
                <hr></hr>
                 <Stack direction="row" spacing={3} justifyContent="center">
                    <label>ChatGPT</label>
                    <label>Gemini</label>
                    <label>DeepSeek</label>
                    <label>MistralAI</label>
                    <label>Alibaba-Qwen</label>
                </Stack>
          </div>
          :
          <div>
                 <hr></hr>
                <Stack direction="row" spacing={1} justifyContent="center">
                  <label style={styleAIModel}>ChatGPT</label>
                  <label style={styleAIModel}>Gemini</label>
                  <label style={styleAIModel}>DeepSeek</label>
                </Stack>

                 <Stack direction="row" spacing={1} justifyContent="center">
                  <label style={styleAIModel}>MistralAI</label>
                  <label style={styleAIModel}>Qwen</label>   
                </Stack>
          </div>
          */}

      { /* Buttons */}
      <br></br>

      {
        !isMobile() ?
        <>
          <div className="pageButtonsContainer">
            <div className="pageButtonsContainer" style={{width:'50%'}}>
            
            <Row>
           
               <Col 
                className='pageButton' 
                onClick={() => navigate(`/aitest/${"start"}`)}
              >
                <div>
                  {changeLanguage('home', 'texttests')}
                </div>
              </Col>
            </Row>
           </div>
          <br/>
          
            <Row>

              <Col 
                className='pageButton' 
                onClick={() => navigate('/copilot')}
              >
                <div>
                  {changeLanguage('home', 'textassistant')}
                </div>
              </Col>

              <Col 
                className='pageButton' 
                onClick={() => navigate('/comprehensiveresponses')}
              >
                <div>
                  {changeLanguage('home', 'textcomprehensiveresponses')}
                </div>
              </Col>

              <Col 
                className='pageButton' 
                onClick={() => navigate('/common')}
              >
                <div>
                  {changeLanguage('home', 'textcommon')}
                </div>
              </Col>

            </Row>
      </div>

      <br></br>

      <div className="pageButtonsContainer">
            
            <Row>

              <Col 
                className='pageButton' 
                onClick={() => navigate('/templates')}
              >
                <div>
                  {changeLanguage('home', 'texttemplates')}
                </div>
              </Col>
             
             {/*
             <Col 
                className='pageButton' 
                onClick={() => navigate('/compareai')}
              >
                <div>
                  {changeLanguage('home', 'textompareaimodels')}
                </div>
              </Col>
              */}

              <Col 
                className='pageButton' 
                onClick={() => navigate('/jobinterview')}
              >
                <div>
                  {changeLanguage('home', 'textjobinterview')}
                </div>
              </Col>
            </Row>

          {
            isMe() &&
            <>
            <br/>
           <Row>

            <Col 
                className='pageButton' 
                onClick={() => navigate('/stocks')}
              >
                <div>
                  {changeLanguage('home', 'textstocks')}
                </div>
              </Col>

           
             <Col 
                className='pageButton' 
                onClick={() => navigate('/documentanalysis')}
              >
                <div>
                  {changeLanguage('home', 'textdocumentanalysis')}
                </div>
              </Col>
          
            </Row>
            </>
          }
      </div>
      <br></br>
     
      </>
           
    :
     <div className="pageButtonsContainer">

          <Row>  
           
              <Col 
                className='pageButton' 
                onClick={() => navigate(`/aitest/${"start"}`)}
              >
                <div>
                  {changeLanguage('home', 'texttests')}
                </div>
              </Col>
            
          </Row>
      
          <Row>

            <Col 
                className='pageButton' 
                onClick={() => navigate('/copilot')}
              >
                <div>
                  {changeLanguage('home', 'textassistant')}
                </div>
              </Col>
          </Row>
          
            
          <Row>

            <Col 
                className='pageButton' 
                onClick={() => navigate('/comprehensiveresponses')}
              >
                <div>
                  {changeLanguage('home', 'textcomprehensiveresponses')}
                </div>
              </Col>
          </Row>


          <Row>

               <Col 
                className='pageButton' 
                onClick={() => navigate('/common')}
              >
                <div>
                  {changeLanguage('home', 'textcommon')}
                </div>
              </Col>
          </Row>

          <Row>

                <Col 
                className='pageButton' 
                onClick={() => navigate('/templates')}
              >
                <div>
                  {changeLanguage('home', 'texttemplates')}
                </div>
              </Col>
          </Row>

          {/*
          <Row>
           
                <Col 
                className='pageButton' 
                onClick={() => navigate('/compareai')}
              >
                <div>
                  {changeLanguage('home', 'textompareaimodels')}
                </div>
              </Col>
          </Row>
          */}

          <Row>
            
               <Col 
                className='pageButton' 
                onClick={() => navigate('/jobinterview')}
              >
                <div>
                  {changeLanguage('home', 'textjobinterview')}
                </div>
              </Col>
          </Row>

        {
          isMe() &&
          <>
          <Row>
             
               <Col 
                className='pageButton' 
                onClick={() => navigate('/stocks')}
              >
                <div>
                  {changeLanguage('home', 'textstocks')}
                </div>
              </Col>
          </Row>

           <Row>
           
             <Col 
                className='pageButton' 
                onClick={() => navigate('/documentanalysis')}
              >
                <div>
                  {changeLanguage('home', 'textdocumentanalysis')}
                </div>
              </Col>
            </Row>
          </>
        }
      
      </div>
  }
  
 

      <div style = {{fontSize:'18px', fontWeight: '500', color: 'black', marginTop:'20px',textAlign:'center'}}>
              {changeLanguage('home', 'texthome1')}
      </div>
      <br></br>

       <div className="homenewText">
          <div className="homecontainerTextWithIcon">
            <div className="homeWithIconTextArea">
              <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features1')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_1')} </div>
              <br></br>
                <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features2')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_2')}</div>
              <br></br>
                 <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features3')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_3')}</div>
              <br></br>
                 <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features4')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_4')}</div>
              <br></br>
                 <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features5')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_5')}</div>
              <br></br>
                  <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features6')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_6')}</div>
               
              <br></br>
                  <span style={{fontWeight:'500'}}>{changeLanguage('home', 'features7')} </span>
              <br></br>
               <div className="notesubtext">{changeLanguage('home', 'features_7')}</div>
              <br></br>
                
         
            </div>

          </div>
      </div>
      <br></br>
   
      <hr></hr>
          
        <LoginDialog />
        <DialogLogout alertYes={confirmYes} openDialog = {openLogoutDialog} closeDialog = {closeLogoutDialog} prompt={dialogLogoutText}/>

    </div>

  )
}

export default HomeNew